'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_OpaqueType$package$Person$1(name, password) {
  this.wl = null;
  this.wm = null;
  this.wl = name;
  this.wm = password;
}
export { $c_Lsamples_OpaqueType$package$Person$1 as $c_Lsamples_OpaqueType$package$Person$1 };
$p = $c_Lsamples_OpaqueType$package$Person$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_OpaqueType$package$Person$1;
/** @constructor */
function $h_Lsamples_OpaqueType$package$Person$1() {
}
export { $h_Lsamples_OpaqueType$package$Person$1 as $h_Lsamples_OpaqueType$package$Person$1 };
$h_Lsamples_OpaqueType$package$Person$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 1890237178, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsamples_OpaqueType$package$Person$1) && ((this.wl === x$0.wl) && (this.wm === x$0.wm))));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "Person";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.wl;
  }
  if ((n === 1)) {
    return this.wm;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lsamples_OpaqueType$package$Person$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ei)));
}
export { $isArrayOf_Lsamples_OpaqueType$package$Person$1 as $isArrayOf_Lsamples_OpaqueType$package$Person$1 };
var $d_Lsamples_OpaqueType$package$Person$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_OpaqueType$package$Person$1, "samples.OpaqueType$package$Person$1", ({
  ei: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_OpaqueType$package$Person$1 as $d_Lsamples_OpaqueType$package$Person$1 };
